import {ensureStoresExist} from "../../../Services/BrowserDatabaseFunctions";
import {openDb} from "../../../Services/BrowserDatabaseIDB";


export function addEventPhoto(photo) {
    const lookupId = photo.temp_id || photo.id;

    return openDb('pa', 1, ensureStoresExist).then(function (db) {
        // 1. Open both stores in a single 'readwrite' transaction
        const tx = db.transaction(['Photos', 'Events'], 'readwrite');
        const photoStore = tx.objectStore('Photos');

        // TASK A: Update the heavy 'Photos' store
        const photoTask = photoStore.get(lookupId).then(existingPhoto => {
            let photoToSave;
            if (existingPhoto) {
                // Phase 2: Sync update
                photoToSave = {
                    ...existingPhoto,
                    ...photo,
                    status: 1,
                };
            } else {
                // Phase 1: New upload
                photoToSave = { ...photo };
                delete photoToSave.file;
            }
            return photoStore.put(photoToSave).then(() => photoToSave);
        });

        // Wait for both operations to complete within the same transaction
        return Promise.all([photoTask]);
    })
        .then(() => {
            console.log(`Database Sync Complete for Event: ${photo.event_id}, Photo: ${lookupId}`);
            return true;
        })
        .catch(error => {
            console.error("IndexedDB Multi-Store Sync Error:", error);
            throw error;
        });
}

/**
 * Synchronizes the local database after a successful server finalize.
 * Moves the photo data to the new permanent ID and updates the event registry.
 */
export async function finalizePhotoInDb(_event_id, _temp_id, _id) {

    return openDb('pa', 1, ensureStoresExist).then(async (db) => {
        const tx = db.transaction(['Photos', 'Events'], 'readwrite');
        const photoStore = tx.objectStore('Photos');
        const eventStore = tx.objectStore('Events');

        // 1. UPDATE PHOTOS STORE (Migration)
        const photoRecord = await photoStore.get(_temp_id);
        let updatedRecord = null;

        console.log("photoRecord: ", photoRecord);

        if (photoRecord) {
            // Create the new version with the permanent ID
            updatedRecord = {
                ...photoRecord,
                id: _id
            };

            // Save the new record
            await photoStore.put(updatedRecord);
            // Delete the old temporary record
            await photoStore.delete(_temp_id);
        }

        console.log("updatedRecord to be synced: ", updatedRecord);

        // 2. Add/Update the photo in the event
        const eventDoc = await eventStore.get(_event_id);

        if (eventDoc && eventDoc.photos && updatedRecord) {
            // Check if it already exists by permanent ID
            const index = eventDoc.photos.findIndex(p => p.id === _id);

            if (index === -1) {
                // Not found? Push the full updated record
                eventDoc.photos.push(updatedRecord);
            } else {
                // Found? Replace it to ensure data is identical
                eventDoc.photos[index] = updatedRecord;
            }

            // Save the entire updated event document back to IndexedDB
            await eventStore.put(eventDoc);
        }

        return tx.done;
    });
}

export async function addSignedUrlForPhotoForGCS(_event_id, _photo_id, _signed_url) {

    return openDb('pa', 1, ensureStoresExist).then(async (db) => {
        const tx = db.transaction(['Photos', 'Events'], 'readwrite');
        const photoStore = tx.objectStore('Photos');
        const eventStore = tx.objectStore('Events');

        // 1. Update the 'Photos' store (The heavy data)
        const photoRecord = await photoStore.get(_photo_id);
        if (photoRecord) {
            // clear the full_data
            await photoStore.put({ ...photoRecord, full_data: "", signed_url: _signed_url});
        }

        // 2. Update the 'Events' store (The registry array)
        const eventDoc = await eventStore.get(_event_id);
        if (eventDoc && eventDoc.photos) {
            const index = eventDoc.photos.findIndex(p => p.id === _photo_id);

            if (index > -1) {
                eventDoc.photos[index] = {
                    ...eventDoc.photos[index],
                    file: null,
                    full_data: "",
                    signed_url: _signed_url
                };
                await eventStore.put(eventDoc);
            }
        }

        return tx.done;
    });
}

/**
 * Deletes a photo from both the 'Photos' store and the embedded array in 'Events'.
 *
 * @param {string} eventId - The ID of the event containing the photo.
 * @param {string} photoId - The permanent ID (or temp_id) of the photo to remove.
 */
export async function deleteEventPhoto(eventId, photoId) {
    return openDb('pa', 1, ensureStoresExist).then(async (db) => {
        // 1. Open both stores in a single readwrite transaction
        const tx = db.transaction(['Photos', 'Events'], 'readwrite');
        const photoStore = tx.objectStore('Photos');
        const eventStore = tx.objectStore('Events');

        // TASK 1: Remove from the standalone 'Photos' store
        await photoStore.delete(photoId);

        // TASK 2: Remove from the embedded 'photos' array inside the 'Events' store
        const eventDoc = await eventStore.get(eventId);

        if (eventDoc && Array.isArray(eventDoc.photos)) {
            // Filter out the photo by matching either permanent 'id' or 'temp_id'
            const originalCount = eventDoc.photos.length;
            eventDoc.photos = eventDoc.photos.filter(
                (p) => p.id !== photoId && p.temp_id !== photoId
            );

            // Only perform a put if a photo was actually removed
            if (eventDoc.photos.length !== originalCount) {
                await eventStore.put(eventDoc);
            }
        }

        return tx.done;
    })
        .then(() => {
            console.log(`Successfully removed Photo: ${photoId} from Event: ${eventId} in IndexedDB.`);
            return true;
        })
        .catch((error) => {
            console.error(`IndexedDB Delete Photo Error for ${photoId}:`, error);
            throw error;
        });
}